import { render, staticRenderFns } from "./McrFormShp.vue?vue&type=template&id=33087e23"
import script from "./McrFormShp.vue?vue&type=script&lang=js"
export * from "./McrFormShp.vue?vue&type=script&lang=js"
import style0 from "./McrFormShp.vue?vue&type=style&index=0&id=33087e23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports